import { render } from "./HeroiconsOutlineRewind.vue?vue&type=template&id=0b50b730"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineRewind.vue"]])

export default __exports__